const TextField = ({
  label,
  inputHandler,
  value,
  type,
  // validateNameHandler,
}) => {
  const dataHandler = (event) => {
    inputHandler(event.target.value);
  };

  return (
    <div className='form-container'>
      <div className='form__field'>
        <label className='form__field-label capitalize' htmlFor={label}>
          {label}
        </label>
        <input
          className='form__field-input'
          type={type}
          id={label}
          name={label}
          value={value}
          onChange={dataHandler}
          // onBlur={validateNameHandler}
        ></input>
      </div>
    </div>
  );
};

export default TextField;
